import { Tag, Tooltip } from '@chakra-ui/react';
import React from 'react';
import { useGetRemoteSubmissionInvitesSuspense } from '../../../../../services/api/generated/client';
import { FIVE_MIN_STALE_TIME } from '../../../../../services/api/query/queryClient';
import { localise, pluralise } from '../../../../../services/lang/lang';
const TenantReportsInviteCountChip = ({ inspectionId, onClickChip, }) => {
    const { data: response, isError } = useGetRemoteSubmissionInvitesSuspense(inspectionId, {
        should_paginate: 1,
    }, {
        query: {
            staleTime: FIVE_MIN_STALE_TIME,
        },
    });
    const inviteCount = response?.data.meta?.total;
    if (isError || !inviteCount)
        return null;
    return (React.createElement(Tooltip, { "aria-label": localise('VIEW_INVITES'), label: localise('VIEW_INVITES'), placement: "right", hasArrow: true },
        React.createElement(Tag, { onClick: onClickChip, variant: "grey", cursor: "pointer", "data-testid": "tenant_reports_invite_count_chip" }, `${inviteCount} ${pluralise(localise('INVITE').toLowerCase(), inviteCount)} ${localise('SENT').toLowerCase()}`)));
};
export default TenantReportsInviteCountChip;
